import React from "react";

interface EmailValidatedComponentProps {
  text: string;
  setText: (value: string) => void;
  required?: boolean;
  className?: {
    parentDiv?: React.CSSProperties;
    label?: React.CSSProperties;
    input?: React.CSSProperties;
  };
  disabled?: boolean;
}

const EmailValidatedComponent = ({
  text,
  setText,
  required = false,
  className = {
    parentDiv: {},
    input: {},
  },
}: EmailValidatedComponentProps) => {

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setText(value);

    if (value?.trim() === "") {
      e.target.setCustomValidity("");
    } else {
      const isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/gm.test(value);
      e.target.setCustomValidity(isValid ? "" : "Please enter a valid email");
    }
  };

  return (
    <div style={className.parentDiv}>
      <input
        type="email"
        value={text}
        onChange={handleChange}
        required={required}
        style={className.input}
        className={`w-full px-[8px] py-[8px] border rounded-md outline-none text-sm bg-transparent`}
      />
    </div>
  );
};


export default EmailValidatedComponent;